import * as angular from "angular";

export class BuildingService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = "/v2/building";
    }

    all(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/all/", data);
    }

    info(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/" + data.id, data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/update/" + data.id, data);
    }
}

angular.module("vcServices").service("BuildingService", BuildingService);
